<template>
  <v-card class="ma-5">

    <div class="d-flex">
      <div class="flex-grow-1">

        <v-card-title class="text-headline-small">Pressione CPU</v-card-title>
        <v-card-text>
            <template v-if="systemStore.pressureSupported">
            <p 
              v-if="systemStore?.lastRecordPressure?.time"
            >
            L'indicatore mostra la percentuale di utilizzo dello spazio di archiviazione.<br>
            Vengono mostrate la disponibilità totale, la quota utilizzata e il dettaglio per tipologia.<br>
            Lo spazio di archiviazione utilizzato è la somma di tutte le risorse memorizzate.
          </p>
          <p class="d-flex flex-row align-center mt-0 mb-6">
            <v-progress-circular
                :title="systemStore?.lastRecordPressure?.time"
                :model-value="pressureOwnContributionEstimatePercent"
                :size="128"
                :width="24"
                :color="pressureOwnContributionEstimateColor"
            >{{ pressureOwnContributionEstimatePercent }} %</v-progress-circular>
              <span class="ml-4 text-title-large text-grey-darken-2">{{ systemStore.lastRecordPressure?.source }}:</span>
              <span 
                :class="`ml-4 text-title-large font-weight-bold text-${pressureOwnContributionEstimateColor}`"
              >
                {{ systemStore.lastRecordPressure?.state }}
              </span>
            </p>

<!-- 
        {{systemStore.lastRecordPressure}}<br>
        state: {{systemStore.lastRecordPressure?.state}}<br>
        source: {{systemStore.lastRecordPressure?.source}}<br>
        time: {{systemStore.lastRecordPressure?.time}}<br>
        ownContributionEstimate: {{systemStore.lastRecordPressure?.ownContributionEstimate}}<br>
        ownContributionEstimatePercent: {{pressureOwnContributionEstimatePercent}}<br> -->

          </template>
          <template v-else>
            <p class="font-italic">
              Il motore della webview in uso non supporta l'interfaccia Pressure.
            </p>
          </template>
          </v-card-text>

          <v-card-title class="text-headline-small">Memoria volatile</v-card-title>
        <template v-if="systemStore?.memorySample">
          
          <v-card-text>
          <p class="d-flex flex-row align-center mt-0 mb-6">
            L'indicatore mostra la percentuale di utilizzo dello spazio di archiviazione.<br>
            Vengono mostrate la disponibilità totale, la quota utilizzata e il dettaglio per tipologia.<br>
            Lo spazio di archiviazione utilizzato è la somma di tutte le risorse memorizzate.
          </p>
          <p class="d-flex flex-row align-center mt-0 mb-6">
            <v-progress-circular
                :title="systemStore.usageMemoryPercent"
                :model-value="systemStore.usageMemoryPercent"
                :size="128"
                :width="24"
                :color="usageMemoryColor"
            >{{ systemStore.usageMemoryPercent }} %</v-progress-circular>
            <span class="ml-4 text-title-large text-grey-darken-2">{{ systemStore.BytesValueToHR(systemStore.memorySample?.bytes) }}&nbsp;/ {{ systemStore.deviceMemory }}&nbsp;GB</span>
          </p>
        </v-card-text>


            <v-card-title class="text-title-large text-grey-darken-2">Consumo</v-card-title>
          <v-card-text>
            <p class="ps-5 pb-0 mb-0">
              <strong>{{ systemStore.BytesValueToHR(systemStore.memorySample?.bytes) }}</strong><br>
            </p>
              <p class="ps-8 pt-1 pb-0 mb-0">Ultimo aggiornamento: {{ new Date(systemStore.memorySampleTimestamp).toLocaleTimeString() }}</p>
              <p class="ps-8 pt-0 mt-0  ">Prossimo aggiornamento: {{ systemStore.nextMemorySampleInSeconds }}s</p>

            <!-- Breakdown dettagliato: <br> -->
            <!-- <pre class="mt-3">{{ systemStore?.memorySample }}</pre> -->
            <p v-if="systemStore?.memorySample?.breakdown">
              <v-table
                  density='compact'
                  hover
                  class="w-auto d-inline-block"
              >
                <thead>
                  <tr>
                    <th class="text-left">
                      Posizione</th>
                    <th class="text-left">
                      Dimensione</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                  </tr>

                  <tr v-for="b in systemStore.memorySample.breakdown.filter(b => b?.bytes > 0)">
                    <td>{{ b?.types?.join("-") }}</td>
                    <td>{{ systemStore.BytesValueToHR(b?.bytes) }} <br></td>
                  </tr>
                </tbody>
              </v-table>
            </p>
          </v-card-text>
          </template>

          <template v-else>
          <v-card-text>

            <p class="font-italic">
              Il motore della webview in uso non supporta l'interfaccia Performance.<br>
            </p>
          </v-card-text>
          </template>



        <v-card-item>
          <v-card-title class="text-headline-small">Memoria persistente</v-card-title>
        </v-card-item>

        <v-card-text v-if="!systemStore.usageDetailsNotSupported">
          <p>
            L'indicatore mostra la percentuale di utilizzo dello spazio di archiviazione.<br>
            Vengono mostrate la disponibilità totale, la quota utilizzata e il dettaglio per tipologia.<br>
            Lo spazio di archiviazione utilizzato è la somma di tutte le risorse memorizzate.
          </p>
          <p class="d-flex flex-row align-center mt-0 mb-6">
            <v-progress-circular
                :title="systemStore.usage.percent"
                :model-value="systemStore.usage.percent"
                :size="128"
                :width="24"
                :color="usageColor"
            >{{ systemStore.usage.percent }} %</v-progress-circular>
            <span class="ml-4 text-title-large text-grey-darken-2">{{ systemStore.usage[systemStore.usageUnit] }} {{ systemStore.usageUnit }} / {{ systemStore.quota[systemStore.quotaUnit]
            }}
              {{
                systemStore.quotaUnit }}</span>
          </p>
          <!-- <v-btn v-if="systemStore.estimateSupported" color="primary" size="small" @click="showDetails = !showDetails" >
              <v-icon class="mr-2" size="small">mdi-grid</v-icon> dettaglio
            </v-btn> -->
          <!-- <p>
            <pre>{{
              systemStore.usage?.usageDetails
              }}</pre>
          </p> -->
        </v-card-text>
            <v-card-title class="text-title-large text-grey-darken-2">Consumo</v-card-title>
        <v-card-text>

            <div v-show="showDetails">
              <v-table
                  density='compact'
                  hover
                  class="w-auto d-inline-block"
              >
                <thead>
                  <tr>
                    <th class="text-left">
                      Posizione</th>
                    <th class="text-left">
                      Dimensione</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                  </tr>

                  <tr>
                    <td>caches</td>
                    <td v-html="systemStore.usageAmount.caches"></td>
                  </tr>
                  <tr>
                    <td>indexedDB</td>
                    <td v-html="systemStore.usageAmount.indexedDB"></td>
                  </tr>
                  <tr>
                    <td>localStorage</td>
                    <td v-html="systemStore.BytesValueToHR(systemStore.usageAmount.localStorage)"></td>
                  </tr>
                  <tr>
                    <td>sessionStorage</td>
                    <td v-html="systemStore.BytesValueToHR(systemStore.usageAmount.sessionStorage)"></td>
                  </tr>
                </tbody>
              </v-table>
              <v-spacer />
            </div>


        </v-card-text>


        <div v-if="systemStore.usageDetailsNotSupported">
          <v-card-title class="text-title-large text-grey-darken-2">Dettagli utilizzo</v-card-title>
          <v-card-text>
            <p class="font-italic">
              Il motore della webview in uso non supporta la funzione usageDetails dell'interfaccia Storage.<br>
            </p>
          </v-card-text>
        </div>



        <v-card-title class="text-title-large text-grey-darken-2">Persistenza</v-card-title>
        <v-card-text>

          <p class="font-italic">
            La persistenza della memoria indica la possibilità dell'applicazione di cancellare i dati per liberare
            spazio,
            eventualmente e a propria discrezione.
          </p>
          <p class="mb-3">
            <v-icon :color="systemStore.storagePersistent.state ? 'green-darken-2' : 'red-darken-2'">{{ systemStore.storagePersistent.icon
            }}</v-icon>
            {{ systemStore.storagePersistent.description }}
          </p>
        </v-card-text>





      </div>
    </div>
  </v-card>
</template>

<script setup>

import { ref, computed, onMounted } from "vue";

import { useSystemStore } from "@/store/system";
import { add } from "ol/coordinate";

const systemStore = useSystemStore();

const showDetails = ref(true)

const usageColor = computed(() => {
  if (systemStore.usage.value?.percent < 50) {
    return "success";
  } else if (systemStore.usage.value?.percent < 75) {
    return "warning";
  } else {
    return "error";
  }
})


const usageMemoryColor = computed(() => {
  if (systemStore.usageMemoryPercent < 50) {
    return "success";
  } else if (systemStore.usageMemoryPercent < 75) {
    return "warning";
  } else {
    return "error";
  }
})




const pressureOwnContributionEstimatePercent = computed(() => {
  // return  systemStore.lastRecordPressure.ownContributionEstimate 
  return parseInt(systemStore.lastRecordPressure?.ownContributionEstimate * 100) || 0
})

const pressureOwnContributionEstimateColor = computed(() => {
  if (pressureOwnContributionEstimatePercent.value < 25) {
    return "gray-darken-2";
  } else if (pressureOwnContributionEstimatePercent.value < 50) {
    return "success";
  } else if (pressureOwnContributionEstimatePercent.value < 75) {
    return "warning";
  } else {
    return "error";
  }
})

// const pressureStateValue = computed(()=>{
//   systemStore.lastRecordPressure.value?.state
// })


</script>

<style scoped>
.pulsating {
  animation-name: color;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}


@keyframes color {
  from {
    color: orange;
  }

  to {
    color: white;
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px orange;
  }
}

.no-mouse {
  pointer-events: none;
}

.v-expansion-panels {
  width: auto;
  min-width: 25em
}
</style>
